










import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import ToolBadge from '@/components/Utilities/ToolBadge.vue';
import openbitlab from '@/types.d';
import { values } from 'lodash';

@Component({
  components: {
    ToolBadge,
  },
})
export default class Tools extends Vue {
  @State('tools') tools!: openbitlab.RootState['tools']

  getTools(): Array<openbitlab.Tool> {
    return values(this.tools);
  }
}
